import { render, staticRenderFns } from "./CartBottomAction.vue?vue&type=template&id=2385dbe0&scoped=true&"
import script from "./CartBottomAction.vue?vue&type=script&lang=js&"
export * from "./CartBottomAction.vue?vue&type=script&lang=js&"
import style0 from "./CartBottomAction.vue?vue&type=style&index=0&id=2385dbe0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2385dbe0",
  null
  
)

export default component.exports